import { render } from "./FbRadioField.vue?vue&type=template&id=0a5480a8"
import script from "./FbRadioField.vue?vue&type=script&lang=js"
export * from "./FbRadioField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__